{
	"add": {
		"button": "Add publisher",
		"confirm": "Continue",
		"duplicate": "“{{name}}” is already listed.",
		"hint": "Only needed for a publisher that does not appear in any document yet: every other one is already listed. Type the name exactly as it is in Mr.Book.",
		"open_existing": "Open it",
		"placeholder": "Publisher name",
		"title": "Add publisher"
	},
	"channel": {
		"all": "All",
		"esclusiva": "Exclusive",
		"ingrosso": "Wholesale"
	},
	"columns": {
		"channel": "Channel",
		"publisher": "Publisher",
		"sold": "Sold"
	},
	"filter_region": "Region",
	"no_document": "The list comes from the latest generated document. Generate one and publishers will show up here.",
	"no_match": "No publisher matches the filters.",
	"page_description": "Where Mantegna is the exclusive distributor, region by region. Every other publisher is wholesale. Changes apply to documents generated from now on.",
	"page_title": "Exclusives",
	"region_header_title": "Exclusive publishers in {{region}}: {{count}}",
	"region_mark": "Exclusive in {{region}}",
	"regions": {
		"abruzzo": "Abruzzo",
		"basilicata": "Basilicata",
		"calabria": "Calabria",
		"campania": "Campania",
		"lazio": "Lazio",
		"molise": "Molise",
		"puglia": "Puglia",
		"sardegna": "Sardinia",
		"sicilia": "Sicily",
		"toscana": "Tuscany",
		"umbria": "Umbria"
	},
	"search_placeholder": "Search a publisher",
	"sheet": {
		"add": "Add",
		"channel": "Channel",
		"copy_from": "Copy from another publisher",
		"copy_from_label": "Combinations already in use, most common first",
		"copy_like": "Like {{name}}",
		"copy_like_others_one": "Like {{name}} and 1 more",
		"copy_like_others_other": "Like {{name}} and {{count}} more",
		"effective": "Applies to documents generated from now on.",
		"esclusiva_hint": "Mantegna is the exclusive distributor in at least one region. Higher safety stock.",
		"gains": "On save, {{name}} moves from wholesale to exclusive.",
		"ingrosso_hint": "No exclusive region. Standard safety stock.",
		"loses": "On save, {{name}} loses the exclusive in {{regions}} and moves to wholesale.",
		"new_publisher": "Not in any generated document yet.",
		"not_in_document": "Not in the latest generated document.",
		"regions": "Exclusive regions",
		"regions_count": "{{count}} of {{total}}",
		"regions_required": "Pick at least one region, or choose Wholesale.",
		"regions_required_new": "Pick at least one region.",
		"save": "Save",
		"sold": "Sold in the previous campaign: {{sold}} copies"
	},
	"toast": {
		"regions_updated": "{{name}} regions updated. They apply to documents generated from now on.",
		"to_esclusiva": "{{name}} moves to exclusive. Applies to documents generated from now on.",
		"to_ingrosso": "{{name}} moves to wholesale. Applies to documents generated from now on.",
		"undo": "Undo",
		"undone": "Change undone.",
		"change_updated": "{{name}} channel change updated. Applies to the next generated documents."
	},
	"change": {
		"gained": "Exclusivity gained in {{year}}",
		"gained_hint": "In {{previous}} we sold it wholesale: quantities are rescaled to the sales of exclusive publishers.",
		"gained_short": "gained in {{year}}",
		"legend": "Channel change",
		"lost": "Exclusivity lost in {{year}}",
		"lost_hint": "In {{previous}} we were the exclusive distributor: quantities are rescaled to the sales of wholesale publishers.",
		"lost_short": "lost in {{year}}",
		"none": "No change",
		"none_hint": "Same channel as the {{previous}} campaign."
	}
}
